// extracted by css-extract-rspack-plugin
export default {"greyBand":"recommendedProperties-module__greyBand"};